<div *ngIf="!isSuccess">
  <h1>Access Code</h1>
  <p>To unlock the songs in your new collection, 
    enter the Access Code from the inside cover of 
    the Teacher Songbook.</p>
  <div class='code'>
    <label>Enter Access Code</label>
    <input placeholder='Access Code' #inputAccessCode autoFocus [(ngModel)]='accessCode'>
    <ion-spinner class='waiting' name='circles' [hidden]='!waiting'></ion-spinner>
  </div>
  <div class='buttons'>
    <button class='cancel' [disabled]='waiting' (click)='cancel()'>Cancel</button>
    <button class='submit' [disabled]='waiting' (click)='submit()'>Submit</button>
  </div>
</div>

<div *ngIf="isSuccess">
  <h1 class="text-center">Success!</h1>
  <p class="text-center">
    You unlocked a new collection.
  </p>
  <div class='buttons btn'>
    <button class='submit w-100' (click)='cancel()'>Close</button>
  </div>
</div>
